import { useEffect } from "react";
import { useMap } from "react-leaflet";

export const AccessibleLabels = () => {
    const map = useMap();

    useEffect(() => {
        if (map._container) {
            map._container.setAttribute("tabIndex", "-1");
        }

        const zoomIn = map.zoomControl?._container.querySelector(".leaflet-control-zoom-in");
        const zoomOut = map.zoomControl?._container.querySelector(".leaflet-control-zoom-out");
        const marker = map._container.querySelector(".leaflet-marker-icon");

        if (zoomIn) {
            zoomIn.setAttribute("aria-label", "nagyítás");
            zoomIn.setAttribute("title", "nagyítás");
        }

        if (zoomOut) {
            zoomOut.setAttribute("aria-label", "kicsinyítés");
            zoomOut.setAttribute("title", "kicsinyítés");
        }
        
        if (marker) {
            marker.setAttribute("aria-label", "hely jelző");
            marker.setAttribute("title", "hely jelző");
        }

    }, [map]);

    return null;
};